import { Component, OnInit } from '@angular/core';
import { PosFloatingActionButtonService } from 'src/app/@core/services/pos-floating-action-button.service';

@Component({
  selector: 'app-return-invoices',
  templateUrl: './return-invoices.component.html',
  styleUrls: ['./return-invoices.component.sass']
})
export class ReturnInvoicesComponent implements OnInit {

  constructor(private floatingService: PosFloatingActionButtonService) {
    this.floatingService.setShow(false);
    this.floatingService.addItems();
  }

  ngOnInit(): void {
  }

}
